export default __webpack_public_path__ + "static/media/banner.a5f9d58d.jpg";